<div class="login-card">
    <div>
        <div class="login-main">
            <div class="theme-form">
                <h4 style=" font-size: 22px;margin-bottom:20px">Contact Us</h4>
                <p *ngIf="!success_message">Contact Us by submitting the below form</p>
                <div *ngIf="!success_message" class="form-group">
                    <label class="col-form-label pt-0">Your Name</label>
                    <div class="row">
                        <div class="col-6">
                            <input [(ngModel)]="form.firstName" class="form-control" type="text" required="" placeholder="First name">
                        </div>
                        <div class="col-6">
                            <input [(ngModel)]="form.lastName" class="form-control" type="text" required="" placeholder="Last name">
                        </div>
                    </div>
                </div>
                <div *ngIf="!success_message">
                    <label class="col-form-label">Mobile Number</label>
                    <div class="form-group">
                        <form class="example-form" style="padding: 0px;" [formGroup]="mobileForm">
                            <ngx-mat-intl-tel-input style="background-color: #f3f3ff !important;" class="form-control" [preferredCountries]="['ae', 'sa', 'jo']"
                                                    [enablePlaceholder]="true"
                                                    [enableSearch]="true"
                                                    name="phone" formControlName="phone"
                                                    describedBy="phoneInput"></ngx-mat-intl-tel-input>
                        </form>
                    </div>
                </div>
                <div *ngIf="!success_message" class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input [(ngModel)]="form.emailAddress" class="form-control" type="email" required="" placeholder="name@company.com">
                </div>
                <div *ngIf="!success_message" class="form-group">
                    
                    <label class="col-form-label">Organization</label>
                    <input type="text"
                           aria-label="Organization" class="form-control"
                           matInput
                           [formControl]="myControl" [(ngModel)]="form.organization.name"
                           [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option.Name">
                            <p (click)="getSelectedOrganization(option)">{{option.Name}}</p>
                        </mat-option>
                    </mat-autocomplete>
                    
                </div>
                <div *ngIf="!success_message" class="form-group">
                    <label class="col-form-label">Message</label>
                    <textarea [(ngModel)]="form.message" class="form-control"  required="" placeholder="Type your message here" style="font-size: 14px; color: rgb(137, 137, 137); background-color: rgb(243, 243, 255); "></textarea>
                </div>
                <div *ngIf="!success_message" class="form-group mb-0">

                    <button (click)="submit()" class="btn btn-primary d-block w-100" type="button">Submit</button>
                    <p *ngIf="error_message">Error on submitting the form. please call us on +971 6 575 0055</p>
                    
                </div>
                <div *ngIf="success_message">
                    <p >Thank you for submitting the form. We will contact you within 1 hour</p>
                </div>
                <p class="mt-4 mb-0">Go Back?<a class="ms-2" [routerLink]="'/auth/login'">Click here</a></p>
            </div>
        </div>
    </div>
</div>